import { apiErrorCode } from "../../components/timetable/runErrors";
import { formatApiError } from "./apiErrors";

// The support endpoints refuse an upload with a machine `code` next to the
// English prose (apps/core/errors.py `fail`). Branch on the code — the same
// contract as slotErrors.js / runErrors.js — so the message arrives in the
// user's language rather than the server's.
const CODE_KEYS = {
  too_many_files: "support.errors.tooManyFiles",
  file_too_large: "support.errors.fileTooLarge",
  bad_file_type: "support.errors.badFileType",
  bad_image: "support.errors.badImage",
  empty_message: "support.errors.emptyMessage",
  // An edit of a message that is not the reader's own (a 403).
  not_your_message: "support.errors.notYourMessage",
};

export function supportErrorMessage(err, t, fallback) {
  const key = CODE_KEYS[apiErrorCode(err)];
  if (key) return t(key);
  return formatApiError(err, fallback);
}
